module.exports = __webpack_public_path__ + "img/title.0f1fab9c.png";